// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText--richText--yxhk_","placeholderAnim":"RichText--placeholderAnim--EPyW5"};